import { put, takeLatest, select } from 'redux-saga/effects';

import { targetUserIdSelector } from '../../context/selectors';
import { consts as reqAssignProviderConsts } from '../reqAssignProvider';
import { consts as removeAssignedProviderConsts } from '../../circles/removeAssignedProvider';
import { actions as reqCircleOfCare } from '../reqCircleOfCare';

function* assignProviderWorker() {
  const targetUserId = yield select(targetUserIdSelector);
  if (targetUserId) {
    yield put(reqCircleOfCare.send({ id: targetUserId }));
  }
}

export default function* assignProviderSaga() {
  yield takeLatest(
    [removeAssignedProviderConsts.SUCCEED, reqAssignProviderConsts.SUCCEED],
    assignProviderWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/assignProvider.js